"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/web.dom.iterable");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  props: {
    currentData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    flag: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isPlatform: localStorage.getItem('identityid') === '11',
      showSelectAuction: false,
      resultData: [],
      selectedAuctionIdList: [],
      selectedAuction: [],
      queryParams: {
        page: 1,
        size: 10
      },
      total: 0,
      courseOnlineTitle: '',
      jump_type: 'kecheng'
    };
  },
  watch: {
    flag: function flag(val) {
      console.log(val);
      this.changeshow();
    }
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {},
  mounted: function mounted() {},
  methods: {
    changeshow: function changeshow() {
      this.showSelectAuction = true;
      this.selectedAuction = JSON.parse(JSON.stringify(this.currentData));
      this.selectedAuctionIdList = this.selectedAuction.map(function (m) {
        return m.id;
      });
      if (this.resultData.length === 0) {
        this.loadCourseOnlineAction();
      }
    },
    searchCourseOnlineAction: function searchCourseOnlineAction() {
      this.queryParams.title = this.courseOnlineTitle;
      this.queryParams.page = 1;
      this.loadCourseOnlineAction();
    },
    loadCourseOnlineAction: function loadCourseOnlineAction(fun) {
      var _this = this;
      var params = this.queryParams;
      var msg = this.$message.loading({
        render: function render(h) {
          return h('span', ['加载中...']);
        },
        duration: 0
      });
      var url = '/listOnlineCourse';
      if (this.jump_type === 'zhuanji') {
        url = '/listOnlineCourseAlbum';
      }
      this.$http.get(url, {
        params: params
      }).then(function (res) {
        msg();
        if (res.code === 200) {
          res.data.data.forEach(function (m) {
            var newM = m;
            if (m.photos) {
              newM.photos = m.photos.split(',')[0];
            }
          });
          _this.total = res.data.total;
          _this.resultData = res.data.data;
          _this.$nextTick(function () {
            // 赋值后马上更新
            if (fun) fun();
          });
        }
      });
    },
    auctionCancelAction: function auctionCancelAction(e, index) {
      this.selectedAuction.splice(index, 1);
      this.selectedAuctionIdList = this.selectedAuction.map(function (m) {
        return m.id;
      });
      if (e) e.preventDefault();
    },
    auctionSelectedAction: function auctionSelectedAction(e, index) {
      var info = this.resultData[index];
      var data = {
        image: info.photos,
        name: info.title,
        id: info.id,
        tags: [],
        price: "\uFFE5".concat(info.price),
        sign: info.hot + '人已听课'
      };
      this.selectedAuction.push(data);
      this.selectedAuctionIdList = this.selectedAuction.map(function (m) {
        return m.id;
      });
      e.preventDefault();
    },
    cursorSelect: function cursorSelect() {
      this.$emit('selectMessage', {
        type: 'courseOnline',
        data: this.selectedAuction
      });
    },
    changePageSize: function changePageSize(size) {
      this.queryParams.size = size;
      this.queryParams.page = 1;
      this.loadAuction();
    },
    changePage: function changePage(page) {
      this.queryParams.page = page;
      this.loadAuction();
    }
  }
};
exports.default = _default2;